import { render } from "./ListItemDestaqueRight.vue?vue&type=template&id=a667bddc&scoped=true"
import script from "./ListItemDestaqueRight.vue?vue&type=script&lang=js"
export * from "./ListItemDestaqueRight.vue?vue&type=script&lang=js"

import "./ListItemDestaqueRight.vue?vue&type=style&index=0&id=a667bddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a667bddc"]])

export default __exports__